import {
  ApeironLinkButton,
  ApeironReactPlayer,
  DEFAULT_ANIMATE_DURATION,
  useFetchYoutubeJson,
  YoutubeJson
} from '@apeiron/temp'
import { Box, styled, Typography } from '@mui/material'
import * as R from 'ramda'
import { useEffect } from 'react'
import { Trans, useTranslation } from 'react-i18next'

const Container = styled(Box)`
  position: relative;
  width: 100%;
  padding: 16px;
`

const Grid = styled(Box)`
  display: grid;

  justify-content: center;
  gap: 16px;

  ${({ theme }) => theme.breakpoints.up('res1280')} {
    grid-template-columns: repeat(3, minmax(338px, 338px));
  }
  ${({ theme }) => theme.breakpoints.between('res768', 'res1280')} {
    grid-template-columns: repeat(2, minmax(338px, 338px));
  }

  ${({ theme }) => theme.breakpoints.down('res768')} {
    grid-template-columns: repeat(1, minmax(338px, 338px));
  }
`

const Item = styled(Box)`
  aspect-ratio: 16/9;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  width: 100%;
  transition: filter ${DEFAULT_ANIMATE_DURATION}ms,
    transform ${DEFAULT_ANIMATE_DURATION}ms;

  :hover {
    filter: brightness(1.1);
    transform: translateY(-3px);
  }
`

const Player = styled(Box)`
  border: 2px solid #ffffff;
  border-radius: 4px;
  width: 100%;
  box-shadow: 0px 40px 150px #bcf8fd44;
`

const Title = styled(Typography)`
  font-weight: 400;
  line-height: 24px;
  text-align: center;
`

const SmallText = styled(Typography)`
  color: #aaaaaa;
  display: flex;
  font-size: 16px;
  font-weight: 300;
  gap: 4px;
  line-height: 16px;
  text-align: center;
`

const Link = styled(ApeironLinkButton)`
  color: #e4c169;
  --text-decoration: underline;
`

const YoutubeGridBlockView = (props: Props) => {
  const { urls } = props

  const { t } = useTranslation()

  const { data, fetch } = useFetchYoutubeJson()

  const youtubes = data || []

  useEffect(() => {
    if (R.isNotEmpty(urls)) {
      fetch(urls)
    }
  }, [urls])

  return (
    <Container>
      <Grid>
        {youtubes.map((youtube: YoutubeJson, index: number) => {
          const key = `og-grid-${index}`

          return (
            <Item key={key}>
              <Player>
                <ApeironReactPlayer url={youtube.url} />
              </Player>
              <Title>{youtube.title}</Title>
              <SmallText>
                <Trans
                  components={{
                    authorLink: <Link url={youtube.authorUrl} target='_blank' />
                  }}
                >
                  {t('youtube.from', { name: youtube.author })}
                </Trans>
              </SmallText>
            </Item>
          )
        })}
      </Grid>
    </Container>
  )
}

type Props = {
  urls: string[]
}

export default YoutubeGridBlockView
